import { useDebugValue, useState } from 'react';
import { interceptErrorMessage } from '../../../../shared/helpers/apiErrorsInterceptor';

import ajaxClient from '../../../../utils/ajaxClient';
import { HEADER_VALUE__CONTENT_TYPE } from '../../../../utils/ajaxClient/constants';

const useSaveDraftQuestionnaireHook = () => {
  useDebugValue('useSaveDraftQuestionnaire');

  const [isSaving, setIsSaving] = useState(false);

  const saveDraftQuestionnaire = (id, data, onSuccess, onError) => {
    setIsSaving(true);
    const url = `Forms/${id}/Draft`;

    return ajaxClient
      .postRequest(url, null, data, HEADER_VALUE__CONTENT_TYPE)
      .then((response) => {
        if (response) {
          setIsSaving(false);
          if (onSuccess) {
            onSuccess();
          }
        }
      })
      .catch((exception) => {
        if (exception) {
          if (onError) {
            onError(interceptErrorMessage(exception));
          }

          setIsSaving(false);
        }
      });
  };

  return { saveDraftQuestionnaire, isSavingDraft: isSaving };
};

export default useSaveDraftQuestionnaireHook;
